// Unity cabina local Y offsets from piano 0, without AnimationClips.
export const ELEVATOR_LEVELS = [0, 6, 11.03817743, 16.03817743]
export const ELEVATOR_SECONDS_PER_FLOOR = 5 / 3

export function elevatorTrip(from, to, startedAt) {
  if (![from, to].every(n => Number.isInteger(n) && n >= 0 && n < 4) || !Number.isFinite(startedAt)) return null
  return { from, to, startedAt, duration: Math.abs(to - from) * ELEVATOR_SECONDS_PER_FLOOR }
}

export function elevatorSample(trip, now) {
  const progress = trip.duration ? Math.max(0, Math.min(1, (now - trip.startedAt) / trip.duration)) : 1
  const eased = progress * progress * (3 - 2 * progress)
  return { offset: ELEVATOR_LEVELS[trip.from] + (ELEVATOR_LEVELS[trip.to] - ELEVATOR_LEVELS[trip.from]) * eased, moving: progress < 1 }
}

export function elevatorNear(position, origin) {
  return Array.isArray(position) && position.length === 3 && position.every(Number.isFinite) &&
    Math.hypot(position[0] - origin.x, position[2] - origin.z) <= 4 &&
    position[1] >= origin.y - 1 && position[1] <= origin.y + ELEVATOR_LEVELS[3] + 3
}

// Feet must be near an actual stop, not simply somewhere within the tall shaft.
export function elevatorLanding(position, origin) {
  if (!elevatorNear(position, origin)) return null
  const floor = ELEVATOR_LEVELS.findIndex(height => Math.abs(position[1] - origin.y - height) <= 0.65)
  return floor < 0 ? null : floor
}

// After a completed journey, give passengers five seconds to disembark before recall.
export function elevatorRecallWait(trip, now) {
  return trip.duration > 0 ? Math.max(0, trip.startedAt + trip.duration + 5 - now) : 0
}
